import React from 'react'
import { Head } from '@inertiajs/react'
import { Clock, Stethoscope } from 'lucide-react'

// Shown at /c/:token when the case-page token is expired or invalid (was a silent redirect to a dead
// home page). Warm, on-brand dead-end with a clear next step — reply on WhatsApp and we resend it.
export default function PublicLinkExpired({ practice = {} }) {
  const name = practice.name || 'Dr Chalita le Roux'
  const wa = (practice.wa || '').toString().replace(/[^\d]/g, '')
  const waLink = wa
    ? `https://wa.me/${wa}?text=${encodeURIComponent("Hi, my treatment plan link has expired — could you please resend it?")}`
    : null

  return (
    <div className="min-h-screen bg-brand-surface/40 py-6 px-4">
      <Head title={`Link expired — ${name}`} />
      <div className="mx-auto max-w-md space-y-5 pt-10">
        <div className="rounded-2xl border border-brand-border bg-white p-6 text-center shadow-sm">
          <div className="flex items-center justify-center gap-2 text-brand-primary">
            <Stethoscope size={18} />
            <span className="text-sm font-semibold">{name}</span>
          </div>
          <div className="mx-auto mt-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-surface">
            <Clock size={22} className="text-brand-primary" />
          </div>
          <h1 className="mt-4 text-lg font-semibold text-brand-ink">This link has expired</h1>
          <p className="mt-2 text-sm text-brand-muted">
            For your privacy, treatment-plan links are only active for a short time. No problem — we can send you a fresh one.
          </p>
          {waLink && (
            <a href={waLink} target="_blank" rel="noopener noreferrer"
               className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:opacity-90">
              Message us on WhatsApp
            </a>
          )}
          {practice.phone && (
            <p className="mt-3 text-xs text-brand-muted">Or call us on {practice.phone}</p>
          )}
        </div>
      </div>
    </div>
  )
}
